import * as React from "react";
import axios from "axios";
import * as settings from "../../settings";
import {
  Grid,
  Typography,
  Card,
  CardActions,
  CardContent,
} from "@mui/material";
import RestorePlan from "./RestorePlan";
import DeletePlan from "./DeletePlan";
import CardColorPicker from "./CardColorPicker";

export default function TrashedPlans(props) {
  const [trashedPlans, setTrashedPlans] = React.useState({});
  const anyTrash = Object.keys(trashedPlans).length > 0;

  function getTrashedPlans() {
    axios
      .post(`${settings.API_SERVER}/api/auth/trash/`, {
        user: localStorage.getItem("username"),
      })
      .then((res) => {
        setTrashedPlans(res.data.data);
      })
      .catch((e) => {
        console.log("error getting plans", e);
      });
  }

  React.useEffect(() => {
    getTrashedPlans();
  }, []);

  if (!anyTrash)
    return (
      <Typography variant="body1">
        You don't have any plans in your trash.
      </Typography>
    );
  else
    return (
      <Grid container spacing={2}>
        {trashedPlans.map((row) => (
          <Grid item xs={12} sm={6} md={6} lg={4} key={row.id}>
            <Card>
              <CardColorPicker plan={row.id} color={row.color} />
              <CardContent sx={{ minHeight: "120px" }}>
                <Typography gutterBottom variant="h5" component="div">
                  {row.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {`Last updated ${row.formatted_date}`}
                </Typography>
              </CardContent>
              <CardActions>
                <RestorePlan
                  id={row.id}
                  settings={props}
                  updateFunc={getTrashedPlans}
                />
                <DeletePlan
                  id={row.id}
                  settings={props}
                  updateFunc={getTrashedPlans}
                />
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
}
